<template lang="pug">
  yz-card-title.d-flex.align-center.justify-space-between(:class="classes" style="width: 100%;")
    .d-flex.align-center
      slot(name="left")
        yz-btn.mr-4(v-if="leftIcon" outlined size="md" :icon="leftIcon" :disabled="loading || disableBack" @click="handleBack")
      slot(name="title")
        .yz-heading-6 {{ title }}
    slot(v-if="!noActions" name="actions")
      .d-flex.align-center(:style="`gap:${getActionGap}`")
        yz-btn(size="lg" text :label="cancelActionLabel" :disabled="loading || disableCancel" @click="handleCancel")
        yz-btn(size="lg" :label="saveActionLabel" :loading="loading" :disabled="disableSave" @click="handleSave")
</template>

<script>
import { getParentClasses, hasPaddingClasses } from '@/utils'

export default {
  name: 'YzDialogFullscreenHeader',
  props: {
    leftIcon: {
      type: String,
      default: 'mdi-arrow-left'
    },
    title: {
      type: String,
      default: null
    },
    actionGap: {
      type: [String, Number],
      default: '12px'
    },
    cancelActionLabel: {
      type: String,
      default: 'Cancel'
    },
    saveActionLabel: {
      type: String,
      default: 'Save'
    },
    loading: {
      type: Boolean,
      default: false
    },
    noActions: {
      type: Boolean,
      default: false
    },
    disableCancel: {
      type: Boolean,
      default: false
    },
    disableSave: {
      type: Boolean,
      default: false
    },
    disableBack: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      const parentClass = getParentClasses(this.$vnode)

      if (hasPaddingClasses(parentClass)) {
        return ''
      }
      return `px-6 py-3 ${parentClass}`.trim()
    },
    getActionGap() {
      return typeof this.actionGap === 'number' ? `${this.actionGap}px` : this.actionGap
    }
  },
  methods: {
    handleBack() {
      this.$emit('back')
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleSave() {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>